module.exports = __webpack_public_path__ + "static/media/XLS.cfb688a7.svg";